<med-popover-trigger menu-id="helpMenu">
  <med-button size="small" color="primary" button-type="flat">
    <span class="button-label">{{'help' | translate }}</span>
    <span class="nav-icon"></span>
  </med-button>
</med-popover-trigger>
<med-menu id="helpMenu">
  <med-menu-item *ngFor="let option of helpMenuUrls; index as i" (click)="onClick(option)">{{ option.menuOption | translate}}</med-menu-item>
</med-menu>
